<template>
  <v-footer class="d-flex flex-column" color="primary">
    <div class="d-flex w-100 align-center px-4 py-0">
      <v-img
        :src="imageUrl"
        alt="EU Logo"
        height="80px"  
        width="150px"
        contain
      />
      <p class="ml-4 px-2">{{footerContent.funding}}</p>
      <div class="d-flex ga-2 ms-auto">
        <v-btn
          v-for="link in socialMediaLinks"
          :key="link.name"
          :icon="link.icon"
          :href="link.link"
          target="_blank"
          size="small"
          variant="plain"
        ></v-btn>
      </div>
    </div>
  </v-footer>
</template>



<script setup>

import { ref, onMounted } from 'vue';

import configService from '@/assets/js-scripts/configService';
const socialMediaLinks = configService.getSocialMediaLinks();
const footerContent = configService.getConfigFooter();

const imageUrl = ref('');

  onMounted(() => {
    imageUrl.value = require('@/assets/eu_logo.png');
  });


</script>


<script>
export default {
  name: 'ProjectFooter'
}
</script>